import { EmptyCell } from 'components/atoms/empty-cell';

export const NoValue = EmptyCell;
